module.exports = __webpack_public_path__ + "static/loader-78fe2e2e92893a4f7d5c754198a60cf3.gif";